<script lang="ts">
  import Icon from './Icon.svelte';

  export let value: string | undefined;
  export let autocomplete: string = '';
  export let placeholder: string = '';
  export let onReset: (() => void) | undefined = undefined;
  export let type: 'text' | 'password' | 'date' = 'text';
  export let min: string | undefined = undefined;
  export let maxlength: number | undefined = undefined;
  export let name: string | undefined = undefined;
  export let dataTestid: string | undefined = undefined;

  let typeAction = (node: HTMLInputElement) => {
    node.type = type;
  };
</script>

<div class="input-wrapper {onReset ? 'button-placeholder' : ''}">
  <input
    use:typeAction
    bind:value
    {placeholder}
    {autocomplete}
    {name}
    on:change
    on:keyup
    {min}
    {maxlength}
    class={type}
    class:empty={!value}
    data-testid={dataTestid}
    {...$$restProps}
  />
  {#if onReset && value && value.length}
    <button class="reset-button" type="reset" on:click={onReset}
      ><Icon variant="close" size="normal" /></button
    >
  {/if}
</div>

<style lang="scss">
  @use '../styles/colors';
  @use '../styles/spacing';

  .input-wrapper {
    background-color: white;
    border: 2px solid colors.$black40;
    border-radius: 4px;
    padding: spacing.$xs spacing.$xs;
    flex: 1;
    display: flex;
    justify-content: space-between;

    input {
      min-width: 215px;
      width: 100%;
      text-align: start;
    }

    &.button-placeholder {
      position: relative;
      padding: spacing.$xs spacing.$l spacing.$xs spacing.$xs;
    }

    .reset-button {
      position: absolute;
      right: spacing.$xs;
      background: colors.$black30;
      border: none;
      border-radius: 50%;
      cursor: pointer;
    }
  }

  input.date {
    color: colors.$black90;
  }
  input.date.empty {
    color: colors.$black60;
  }
</style>
